<div [ngClass]="positionFixed ? 'footer-fixed' : 'footer-nonFixed'" class="footer">
    <div class="row">   
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-break-word bottomDetails">
            <span>Any questions regarding the letter and or information being requested, please refer to the contact
                information within the letter and reach out to the appropriate party.</span> <br>
            <span class="secLine">For questions or issues with this website, please contact <a style="color: white"
                    href="mailto:filecapturesupport@gainwelltechnologies.com">filecapturesupport@gainwelltechnologies.com</a>
                and include the Reference ID from the letter received.</span>
            <div class="">
                <div class="text-white-s ml-5">
                    <a href="https://www.gainwelltechnologies.com/terms-of-use/" target="_blank"
                        class="text-white-s a-link">Terms
                        of Use</a> |
                    <a href="https://www.gainwelltechnologies.com/privacy/" target="_blank"
                        class="text-white-s a-link">Privacy
                        Policy</a> |
                    <a href="https://www.gainwelltechnologies.com/cookies-policy/" target="_blank"
                        class="text-white-s a-link">Cookie
                        Policy</a> |
                </div>
            </div>
        </div>
    </div>
</div>